import { cn } from '@workspace/ui/lib/utils';
import { useProfileUIStore } from '../../profile/store';
import Image from 'next/image';

type Props = {
  url: string;
  children?: React.ReactNode;
  className?: string;
};

export const CoverImage = ({ url, children, className }: Props) => {
  const isMobileView = useProfileUIStore((state) => state.isMobileView);
  return (
    <div
      className={cn('relative w-full h-[180px]', {
        'md:max-w-[745px] md:max-h-[370px] md:h-[370px]': !isMobileView,
      }, className)}
    >
      <Image
        src={url}
        alt="Cover bit image"
        className="w-full h-full object-cover rounded-lg bg-transparent"
        width={745}
        height={370}
      />
      {children}
    </div>
  );
};
